import DataTable from "./components/DataTable";

export default DataTable;